export const FLIGHT_DEPARTURES_STATUSES = [
    {
        id: 1,
        name: 'Доступен',
    },
    {
        id: 2,
        name: 'Не доступен',
    },
]
